import React from 'react';
import Layout from 'layout/Layout';
import PreviewingReservationQuestionnaireComponent from 'components/PreviewingReservationQuestionnaireComponent';

const PreviewingReservationQuestionnairePage: React.FC = () => {
  const pageTitle = '事前アンケート';

  return (
    <Layout pageTitle={pageTitle}>
      <PreviewingReservationQuestionnaireComponent />
    </Layout>
  );
};

export default PreviewingReservationQuestionnairePage;
